import { action, observable } from 'mobx'
import { ModalViewModel } from '@/infra/ModalViewModel'
import type { TrustpilotApi } from '@/features/jobs/details/ratings/TrustpilotApi'

export type TrustpilotCollectorState = 'loading' | 'ready' | 'error'

export class TrustpilotCollectorViewModel {
  readonly modal = new ModalViewModel()

  @observable accessor trustpilotState: TrustpilotCollectorState = 'loading'

  @observable accessor submittedRating: number | null = null

  constructor(public readonly api: TrustpilotApi) {}

  @action.bound
  setTrustpilotState(value: TrustpilotCollectorState) {
    this.trustpilotState = value
  }

  @action.bound
  show(rating: number) {
    this.reset()
    this.submittedRating = rating
    this.modal.show()
  }

  @action.bound
  close() {
    this.modal.close()
    this.reset()
  }

  @action.bound
  reset() {
    this.trustpilotState = 'loading'
    this.submittedRating = null
  }
}
